import { type TooltipPlacement } from "ui/tooltip/tooltip.types";

/** Below, so the full text opens over the rows that follow rather than over the header above it. */
export const TRUNCATED_TEXT_TOOLTIP_PLACEMENT: TooltipPlacement = "bottom";

export const TRUNCATED_TEXT_TOOLTIP_OFFSET_PX = 16;

export const TRUNCATED_TEXT_TOOLTIP_MAX_WIDTH_PX = 320;
